module.exports = __webpack_public_path__ + "static/media/kennedy.3c505a86.jpg";